import styled from "@emotion/styled";
import { ActionIcon, Flex } from "@mantine/core";

export const StyledFileFlex = styled(Flex)`
  gap: 2px;
  align-items: center;
  cursor: pointer;
  border: 1px solid ${({ theme }) => theme.colors.main[5]};
  padding: 2px 6px;
  border-radius: 6px;
`;
